export default __webpack_public_path__ + "static/media/laststep.pic.18c1812d.jpg";